<div class="page-layout">
  <app-toast></app-toast>
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Tools"
      pageSubtitle="Control which tools the assistant can use."
    ></app-navbar>

    <div class="content">

      <div class="tabs-row">
        <div class="tabs">
          <button type="button" class="tab" [class.active]="activeTab() === 'builtin'" (click)="setTab('builtin')">
            Built-in tools <span class="tab-count">({{ sources().length }})</span>
          </button>
          <button type="button" class="tab" [class.active]="activeTab() === 'custom'" (click)="setTab('custom')">
            Your tools <span class="tab-count">({{ customSources().length }})</span>
          </button>
        </div>

        <button type="button" class="register-btn" (click)="openRegisterModal()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"></path></svg>
          Add tool
        </button>
      </div>

      <ng-container *ngIf="activeTab() === 'builtin'">
        <div class="loading-state" *ngIf="isLoading()">
          <div class="spinner"></div>
        </div>

        <div class="empty-state" *ngIf="!isLoading() && loadError()">
          <span class="empty-title">Couldn't load tools.</span>
          <button type="button" class="retry-btn" (click)="loadSources()">Retry</button>
        </div>

        <div class="source-grid" *ngIf="!isLoading() && !loadError()">
          <div class="source-card" *ngFor="let s of sources()">
            <div class="source-top">
              <div class="source-identity">
                <span class="source-badge">{{ initials(s.toolName) }}</span>
                <div class="source-name-block">
                  <span class="source-name">{{ s.toolName }}</span>
                </div>
              </div>

              <button
                type="button"
                class="toggle"
                [class.on]="s.isActive"
                [class.busy]="isToggling(s.toolName)"
                [disabled]="isToggling(s.toolName)"
                [attr.aria-label]="(s.isActive ? 'Disable ' : 'Enable ') + s.toolName"
                (click)="onToggle(s)"
              >
                <span class="toggle-knob"></span>
              </button>
            </div>

            <span class="source-description" [title]="s.description">{{ shortDescription(s) }}</span>

            <div class="source-footer">
              <span class="status-pill" [class.active]="s.isActive">
                <span class="status-dot"></span>
                {{ s.isActive ? 'Active' : 'Disabled' }}
              </span>
              <span class="source-meta">{{ formatUpdatedAt(s.updatedAt) }}</span>
            </div>
          </div>

          <div class="empty-state" *ngIf="sources().length === 0">
            <span class="empty-title">No tools available yet.</span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="activeTab() === 'custom'">
        <div class="loading-state" *ngIf="isLoadingCustom()">
          <div class="spinner"></div>
        </div>

        <div class="empty-state" *ngIf="!isLoadingCustom() && customLoadError()">
          <span class="empty-title">Couldn't load your tools.</span>
          <button type="button" class="retry-btn" (click)="loadCustomSources()">Retry</button>
        </div>

        <div class="source-grid" *ngIf="!isLoadingCustom() && !customLoadError()">
          <div class="source-card" *ngFor="let s of customSources()" (dblclick)="openViewModal(s)" title="Double-click to view">
            <div class="source-top">
              <div class="source-identity">
                <span class="source-badge custom">{{ initials(s.toolName) }}</span>
                <div class="source-name-block">
                  <span class="source-name">{{ s.toolName }}</span>
                  <span class="custom-pill">Your tool</span>
                </div>
              </div>

              <button
                type="button"
                class="toggle"
                [class.on]="s.isActive"
                [class.busy]="isToggling(s.toolName)"
                [disabled]="isToggling(s.toolName)"
                [attr.aria-label]="(s.isActive ? 'Disable ' : 'Enable ') + s.toolName"
                (click)="onToggleCustom(s)"
              >
                <span class="toggle-knob"></span>
              </button>
            </div>

            <span class="source-description" [title]="s.description">{{ s.description }}</span>
            <span class="source-endpoint" [title]="endpointSummary(s)">{{ endpointSummary(s) }}</span>

            <div class="source-footer">
              <span class="status-pill" [class.active]="s.isActive">
                <span class="status-dot"></span>
                {{ s.isActive ? 'Active' : 'Disabled' }}
              </span>

              <div class="custom-actions">
                <span class="source-meta">{{ formatUpdatedAt(s.updatedAt) }}</span>
                <button type="button" class="icon-btn danger" aria-label="Remove tool" (click)="requestDelete(s.toolName); $event.stopPropagation()">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"></path></svg>
                </button>
              </div>
            </div>
          </div>

          <div class="empty-state" *ngIf="customSources().length === 0">
            <span class="empty-title">No tools added yet.</span>
          </div>
        </div>
      </ng-container>

    </div>
  </div>

  <div class="modal-backdrop" *ngIf="showRegisterModal()" (click)="closeRegisterModal()">
    <div class="modal" (click)="$event.stopPropagation()">

      <div class="modal-header">
        <div class="modal-header-text">
          <span class="modal-title">{{ isViewMode() ? formToolName : 'Add tool' }}</span>
          <span class="modal-subtitle">{{ isViewMode() ? 'Editing a tool. Leave a credential field blank to keep it unchanged.' : 'Everything on one screen, nothing hidden behind steps.' }}</span>
        </div>
        <button type="button" class="icon-btn" aria-label="Close" (click)="closeRegisterModal()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"></path></svg>
        </button>
      </div>

      <div class="modal-body">

        <div class="form-section">
          <div class="section-label">
            <span class="section-num">1</span>
            <span class="section-title">Basic info</span>
          </div>

          <div class="field">
            <label for="toolName">Tool name</label>
            <input id="toolName" type="text" placeholder="weather_lookup" [(ngModel)]="formToolName" name="toolName" [readonly]="isViewMode()">
            <span class="field-hint" [class.error]="toolNameHint" *ngIf="!isViewMode()">{{ toolNameHint || 'This becomes the tool\'s name.' }}</span>
          </div>

          <div class="field">
            <label for="description">Description <span class="field-note">shown to the assistant, so it knows when to use this</span></label>
            <textarea id="description" rows="2" placeholder="Gets current weather for a city. Use when the user asks about temperature or conditions." [(ngModel)]="formDescription" name="description"></textarea>
          </div>
        </div>

        <div class="divider"></div>

        <div class="form-section">
          <div class="section-label">
            <span class="section-num">2</span>
            <span class="section-title">Connection</span>
          </div>

          <div class="field">
            <label for="endpointUrl">Endpoint URL</label>
            <input id="endpointUrl" type="text" placeholder="https://api.example.com/v1/current" [(ngModel)]="formEndpointUrl" name="endpointUrl">
          </div>

          <div class="field">
            <label>HTTP method</label>
            <div class="pill-choices">
              <button type="button" *ngFor="let m of httpMethods" class="pill-choice" [class.selected]="formHttpMethod === m" (click)="formHttpMethod = m">{{ m }}</button>
            </div>
          </div>

          <div class="field">
            <label>Authentication</label>
            <div class="auth-grid">
              <button type="button" *ngFor="let a of authTypes" class="auth-choice" [class.selected]="formAuthType === a.value" (click)="formAuthType = a.value">{{ a.label }}</button>
            </div>
          </div>

          <div class="auth-detail" *ngIf="formAuthType === 'apiKey'">
            <div class="field">
              <label for="apiKeyHeader">Header name</label>
              <input id="apiKeyHeader" type="text" [(ngModel)]="formAuthHeaderName" name="apiKeyHeader">
            </div>
            <div class="field">
              <label for="apiKeyValue">API key</label>
              <input id="apiKeyValue" type="password" [placeholder]="isViewMode() ? 'Leave blank to keep the existing key' : ''" [(ngModel)]="formAuthApiKey" name="apiKeyValue">
            </div>
          </div>

          <div class="auth-detail" *ngIf="formAuthType === 'bearer'">
            <div class="field">
              <label for="bearerToken">Bearer token</label>
              <input id="bearerToken" type="password" [placeholder]="isViewMode() ? 'Leave blank to keep the existing token' : ''" [(ngModel)]="formAuthToken" name="bearerToken">
              <span class="field-hint" *ngIf="!isViewMode()">Stored encrypted, never exposed to the frontend again.</span>
            </div>
          </div>

          <div class="auth-detail two-col" *ngIf="formAuthType === 'basic'">
            <div class="field">
              <label for="basicUser">Username</label>
              <input id="basicUser" type="text" [placeholder]="isViewMode() ? 'Leave blank to keep existing' : ''" [(ngModel)]="formAuthUsername" name="basicUser">
            </div>
            <div class="field">
              <label for="basicPass">Password</label>
              <input id="basicPass" type="password" [placeholder]="isViewMode() ? 'Leave blank to keep the existing password' : ''" [(ngModel)]="formAuthPassword" name="basicPass">
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="form-section">
          <div class="section-label">
            <span class="section-num">3</span>
            <span class="section-title">Parameters</span>
            <span class="section-note">what the assistant can pass in when it uses this</span>
          </div>

          <div class="param-header">
            <span>Name</span>
            <span>Type</span>
            <span>Required</span>
            <span>Description</span>
            <span></span>
          </div>

          <div class="param-row" *ngFor="let p of formParameters(); let i = index">
            <input type="text" placeholder="city" [(ngModel)]="p.name" [name]="'paramName' + i">
            <select [(ngModel)]="p.type" [name]="'paramType' + i">
              <option *ngFor="let t of paramTypes" [value]="t">{{ t }}</option>
            </select>
            <button type="button" class="required-check" [class.checked]="p.required" (click)="toggleParamRequired(i)" [attr.aria-label]="p.required ? 'Required' : 'Optional'"></button>
            <input type="text" placeholder="City name, e.g. Austin" [(ngModel)]="p.description" [name]="'paramDesc' + i">
            <button type="button" class="icon-btn" aria-label="Remove parameter" (click)="removeParameterRow(i)">&#10005;</button>
          </div>

          <button type="button" class="add-param-btn" (click)="addParameterRow()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"></path></svg>
            Add parameter
          </button>
        </div>

        <div class="divider"></div>

        <div class="form-section">
          <div class="section-label">
            <span class="section-num">4</span>
            <span class="section-title">Test &amp; review</span>
          </div>

          <div class="review-summary">
            <div class="review-row">
              <span class="review-label">Endpoint</span>
              <span class="review-value">{{ summaryEndpoint }}</span>
            </div>
            <div class="review-row">
              <span class="review-label">Auth</span>
              <span class="review-value">{{ summaryAuth }}</span>
            </div>
            <div class="review-row">
              <span class="review-label">Parameters</span>
              <span class="review-value">{{ summaryParams }}</span>
            </div>
          </div>

          <div class="test-values" *ngIf="namedParameters.length > 0">
            <span class="test-values-label">Sample values &mdash; optional, used only for this test call</span>
            <div class="test-value-row" *ngFor="let p of namedParameters">
              <span class="test-value-name">{{ p.name }}</span>
              <input
                type="text"
                [placeholder]="p.type === 'number' ? '0' : p.type === 'boolean' ? 'true' : 'test'"
                [ngModel]="testValueFor(p.name)"
                (ngModelChange)="updateTestValue(p.name, $event)"
                [name]="'testValue' + p.name"
              >
            </div>
          </div>

          <div class="test-call-row">
            <span class="test-call-label">Test call</span>
            <button type="button" class="test-btn" (click)="runTest()" [disabled]="isTesting() || !formEndpointUrl.trim()">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 4l14 8-14 8V4z"></path></svg>
              {{ isTesting() ? 'Sending...' : 'Send test request' }}
            </button>
          </div>

          <div class="test-placeholder" *ngIf="!testResult()">
            No test run yet &mdash; send a request to preview the response before activating.
          </div>

          <div class="test-response" [class.failed]="testFailed()" *ngIf="testResult() as result">
            <div class="test-response-meta">
              <span *ngIf="result.statusCode !== null">{{ result.statusCode }} &middot; {{ result.durationMs }}ms</span>
              <span *ngIf="result.statusCode === null">Request failed</span>
            </div>
            <pre>{{ result.body }}</pre>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button type="button" class="cancel-btn" (click)="closeRegisterModal()" [disabled]="isSubmitting()">Cancel</button>
        <button type="button" class="submit-btn activate" *ngIf="!isViewMode()" (click)="submitRegister()" [disabled]="!isFormValid || isSubmitting()">
          {{ isSubmitting() ? 'Saving...' : 'Save & Activate' }}
        </button>
        <button type="button" class="submit-btn activate" *ngIf="isViewMode()" (click)="saveEdit()" [disabled]="!isFormValid || isSubmitting()">
          {{ isSubmitting() ? 'Saving...' : 'Save changes' }}
        </button>
      </div>

    </div>
  </div>

  <div class="modal-backdrop" *ngIf="confirmDeleteName()" (click)="cancelDelete()">
    <div class="modal confirm-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="modal-header-text">
          <span class="modal-title">Remove tool</span>
        </div>
      </div>
      <div class="confirm-modal-body">
        <p>
          Remove <code>{{ confirmDeleteName() }}</code>? The assistant will no longer be able to use it.
          You'd need to add it again from scratch.
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="cancel-btn" (click)="cancelDelete()" [disabled]="isDeleting()">Cancel</button>
        <button type="button" class="submit-btn danger" (click)="confirmDelete(confirmDeleteName()!)" [disabled]="isDeleting()">
          {{ isDeleting() ? 'Removing...' : 'Remove tool' }}
        </button>
      </div>
    </div>
  </div>

</div>
